import { Logger } from '@kulee/helper'
import { RESPONSE_CODES } from '@kulee/tga-constant'

// 默认应用编码
export const DEFAULT_APP_CODE = 'tga'

// 日志前缀
export const LOGGER_PREFIX = '__CLAZZ__'
// 日志输出等级
export const LOGGER_LEVEL = Logger.LEVEL.INFO

// 错误映射
export const HTTP_ERROR_MAP: Record<number, string> = {
  // 通用
  400: RESPONSE_CODES.PARAMETER_INVALID,
  401: RESPONSE_CODES.UC_AUTH_INVALID,
  403: RESPONSE_CODES.UC_PERMISSION_INVALID,
  404: RESPONSE_CODES.NOT_FOUND,
  500: RESPONSE_CODES.SERVER_ERROR,
  503: RESPONSE_CODES.SERVER_ERROR,
  10008: RESPONSE_CODES.UC_USER_EXIST,
  10014: RESPONSE_CODES.UC_PASSWORD_INVALID,
  10019: RESPONSE_CODES.UC_USER_NOT_EXIST,
  10009: RESPONSE_CODES.UC_USER_NOT_EXIST
}
